// extracted by mini-css-extract-plugin
module.exports = {"label":"QuarterRock_label__3JWjj","flex":"QuarterRock_flex__1JNSo"};